export function getTranslation(store, key) {
  return store.state.translate.translations[key] || key;
}

export function getTranslationPop(store, key, variable, value) {
  const dictKey = key + ' ' + variable;

  return store.state.translate.translations[dictKey] || value;
}

export function getTranslationParams(store, key, params = [], values = [], text) {
  const dictKey = key;
  let variable = store.state.translate.translations[dictKey];
  if (variable) {
    params.forEach((param, index) => {
      variable = variable.replace(param, values[index]);
    })

    return variable;
  }

  return text;
}
